import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_FACEBOOK_USER,
  SIGNIN_FACEBOOK_USER_SUCCESS,
  SIGNIN_GITHUB_USER,
  SIGNIN_GITHUB_USER_SUCCESS,
  SIGNIN_GOOGLE_USER,
  SIGNIN_GOOGLE_USER_SUCCESS,
  SIGNIN_TWITTER_USER,
  SIGNIN_TWITTER_USER_SUCCESS,
  SIGNIN_USER,
  SIGNINCODE_USER,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER,
  SIGNUP_USER_SUCCESS,
    SIGNINAGENT_USER,
    AGENT_MODE,LIST,POSITION,QHOME,QRESERVE,LISTRESERVE,POSITIONRESERVE,SHARETOKEN,DAMANE,PWA,INSTALLMESSAGE,UPDATE
} from 'constants/ActionTypes';

export const userSignUp = (user) => {
  return {
    type: SIGNUP_USER,
    payload: user
  };
};
export const userSignIn = (user) => {
  return {
    type: SIGNIN_USER,
    payload: user
  };
};
export const userSignInCode = (user) => {
  return {
    type: SIGNINCODE_USER,
    payload: user
  };
};
export const userSignInAgent = (user) => {
  return {
    type: SIGNINAGENT_USER,
    payload: user
  };
};
export const userSignOut = () => {
  return {
    type: SIGNOUT_USER
  };
};
export const userSignUpSuccess = (authUser) => {
  return {
    type: SIGNUP_USER_SUCCESS,
    payload: authUser
  };
};

export const userSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_USER_SUCCESS,
    payload: authUser
  }
};
export const userSignOutSuccess = () => {
  return {
    type: SIGNOUT_USER_SUCCESS,
  }
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};


export const userGoogleSignIn = () => {
  return {
    type: SIGNIN_GOOGLE_USER
  };
};
export const userGoogleSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_GOOGLE_USER_SUCCESS,
    payload: authUser
  };
};
export const userFacebookSignIn = () => {
  return {
    type: SIGNIN_FACEBOOK_USER
  };
};
export const userFacebookSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_FACEBOOK_USER_SUCCESS,
    payload: authUser
  };
};
export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url
  };
};
export const userTwitterSignIn = () => {
  return {
    type: SIGNIN_TWITTER_USER
  };
};
export const userTwitterSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_TWITTER_USER_SUCCESS,
    payload: authUser
  };
};
export const userGithubSignIn = () => {
  return {
    type: SIGNIN_GITHUB_USER
  };
};
export const userGithubSignInSuccess = (authUser) => {
  return {
    type: SIGNIN_GITHUB_USER_SUCCESS,
    payload: authUser
  };
};
export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};
export const hideAuthLoader = () => {
  return {
    type: ON_HIDE_LOADER,
  };
};

export const checkAgent = (check) => {
  return {
    type: AGENT_MODE,
    payload: check
  };
};

export const saveList = (check) => {
  return {
    type: LIST,
    payload: check
  };
};

export const savePosition = (check) => {
  return {
    type: POSITION,
    payload: check
  };
};

export const saveQReserve = (check) => {
  return {
    type: QRESERVE,
    payload: check
  };
};

export const saveQHome = (check) => {
  return {
    type: QHOME,
    payload: check
  };
};

export const saveListRserve = (check) => {
  return {
    type: LISTRESERVE,
    payload: check
  };
};

export const savePositionReserve = (check) => {
  return {
    type: POSITIONRESERVE,
    payload: check
  };
};

export const saveShareToken = (check) => {
  return {
    type: SHARETOKEN,
    payload: check
  };
};

export const saveDamane = (check) => {
  return {
    type: DAMANE,
    payload: check
  };
};


export const savePwa = (check) => {
  return {
    type: PWA,
    payload: check
  };
};

export const saveInstallMessage = (check) => {
  return {
    type: INSTALLMESSAGE,
    payload: check
  };
};

export const saveUpdate = (check) => {
  return {
    type: UPDATE,
    payload: check
  };
};